import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

import Logo from "../../../assets/images/logo-white.png";
import { Flex } from "../../layout";
import { HiMenu } from "react-icons/hi";

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const location = useLocation(); // Utilisation de useLocation pour écouter les changements d'URL

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const links = [
    { name: "Concept", href: "/le-concept" },
    { name: "Lieu", href: "/le-lieu" },
    { name: "Nous connaître", href: "/nous-connaitre" },
    { name: "Ateliers", href: "/ateliers" },
    { name: "Partenaires", href: "/partenaires" },
    { name: "Séjours à venir et passés", href: "/calendrier" },
    { name: "Infos pratiques et Contact", href: "/contact" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname === "/" && window.scrollY < 300 && !isMenuOpen) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    };

    handleScroll(); // Vérifier immédiatement au chargement
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMenuOpen, location.pathname]); // Dépendance sur location.pathname pour détecter les changements de page

  return (
    <nav className={`Navbar ${isActive ? "active" : ""}`}>
      <div className="inner">
        <div className="left">
          <Link to="/" onClick={() => setIsMenuOpen(false)}>
            <img src={Logo} alt="logo l'ecrin sauvage" />
          </Link>
        </div>
        <div className="navbar-menu-toggle">
          <Flex type="center" gap={20}>
            <button className="menu-icon" onClick={toggleMenu}>
              <HiMenu className="icon" />
            </button>
          </Flex>
        </div>
        <ul className={`navbar-links ${isMenuOpen ? "active" : ""}`}>
          {links.map((link, index) => (
            <li key={index}>
              <Link
                to={link.href}
                className={link.button ? "button" : ""}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Nav;
